import { render } from "./facebookMarketing.vue?vue&type=template&id=2ed93442&scoped=true"
import script from "./facebookMarketing.vue?vue&type=script&lang=js"
export * from "./facebookMarketing.vue?vue&type=script&lang=js"

import "./facebookMarketing.vue?vue&type=style&index=0&id=2ed93442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed93442"]])

export default __exports__